import { createAction } from 'redux-actions'

const ns = 'reset-password/'

export const resetPassword = createAction(`${ns}RESET_PASSWORD`)
